import type { PostSubscriptionPreviewRequestBody } from '@gonfalon/openapi/operations/postSubscriptionPreview';

import { BillingIntervals, BillingProcess, LimitNames, PlanTypes } from '../../types';

export function isPostSubscriptionPreviewRequestBody(obj: unknown): obj is PostSubscriptionPreviewRequestBody {
  if (!obj || typeof obj !== 'object') {
    return false;
  }

  const requiredKeys = ['planType', 'billingInterval', 'limits'];
  const hasAllKeys = requiredKeys.every((key) => key in obj);

  if (!hasAllKeys) {
    return false;
  }

  const typedObj = obj as { [key: string]: unknown };

  const planTypeValues = Object.values(PlanTypes as { [key: string]: PlanTypes });
  if (typedObj.planType !== null && !planTypeValues.includes(typedObj.planType as PlanTypes)) {
    return false;
  }

  const billingIntervalValues = Object.values(BillingIntervals as { [key: string]: BillingIntervals });
  if (
    typedObj.billingInterval !== null &&
    !billingIntervalValues.includes(typedObj.billingInterval as BillingIntervals)
  ) {
    return false;
  }

  const billingProcessValues = Object.values(BillingProcess as { [key: string]: BillingProcess });
  if (
    'billingProcess' in typedObj &&
    typedObj.billingProcess !== null &&
    !billingProcessValues.includes(typedObj.billingProcess as BillingProcess)
  ) {
    return false;
  }

  if (typeof typedObj.limits !== 'object' || typedObj.limits === null) {
    return false;
  }

  const limits = typedObj.limits as { [key: string]: number | undefined };
  const limitNameValues = Object.values(LimitNames as { [key: string]: LimitNames });
  return Object.entries(limits).every(
    ([key, value]) => limitNameValues.includes(key as LimitNames) && (typeof value === 'number' || value === undefined),
  );
}
